import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import useHostingNavigate from '~/hooks/useHostingNavigate';
import DomainForm from '~/scenes/AddSetupSiteFlows/components/DomainForm';
import BtnGroup from '~/scenes/AddSetupSiteFlows/components/MultiStepCard/BtnGroup';

import { defaultFormData, FormDataType } from '../..';

export type ConnectDomainPropOptions = {
  formData: FormDataType;
  setFormData?: Function;
  changeLoading?: boolean;
};

const ConnectDomain = ({
  formData,
  setFormData = () => {},
  changeLoading = false,
}: ConnectDomainPropOptions) => {
  const hostingNavigate = useHostingNavigate();
  const [error, setError] = useState(false);
  const { reset, watch, setValue } = useFormContext();
  const value = watch('domain', formData?.domain);

  // preventPath will change when a path is entered/removed by the user (see DomainForm logic)
  // It applies to basic hosting and generic site cases
  const [preventPath, setPreventPath] = useState(false);

  const handleCancel = () => {
    reset(defaultFormData);
    hostingNavigate();
  };

  const disableCTA = () =>
    changeLoading ||
    preventPath ||
    (value === '' && !formData.autoGeneration) ||
    (error && value !== '');

  return (
    <DomainForm
      formData={formData}
      //@ts-expect-error
      setFormData={setFormData}
      preventPath={preventPath}
      setPreventPath={setPreventPath}
      error={error}
      setError={setError}
      value={value}
      setValue={(domain) => setValue('domain', domain)}
    >
      <BtnGroup
        hasSkipBtn={false}
        hasCancelBtn
        onCancelHandler={handleCancel}
        onCloseHandler={handleCancel}
        disabled={disableCTA()}
        loading={changeLoading}
        type={formData.subtype}
        btnType="submit"
      />
    </DomainForm>
  );
};

export default ConnectDomain;
